<template>
  <SysDialog v-model="dialog_ativo" :largura="820" content-class="bra-8" ocultar-acoes>
    <template #titulo.texto>
      <div>
        <p class="ma-0 font-21">Ordenação de colunas</p>
        <p style="color: #64748b" class="ma-0 font-12 mt-n1 font-weight-regular text-gray-800">Arraste e solte os campos
          pelos quais deseja ordenar</p>
      </div>
    </template>

    <div class="d-flex align-center w-full">
      <div class="w-40-porcento pr-1">
        <div class="border-gray-400 w-100-porcento px-4 py-2 header-list">Lista de campos</div>
        <div class="border-gray-400 h-300px overflow-y-auto" @dragover="removerItem(item_sendo_arrastado)">
          <ul class="list-style-type-none ml-n6">
            <li
              v-for="(item, key) in ITENS_NAO_SELECIONADOS"
              :key="key"
              class="d-flex align-center h-30px bg-white pa-5 cursor-grab"
              :draggable="true"
              @dragstart="() => item_sendo_arrastado = item"
              @dragend="() => item_sendo_arrastado = null"
            >
              <span style="color: #0f172a" class="font-14 d-flex align-center">
                <v-icon
                  color="#0f172a"
                  size="22"
                  class="drag-icon mr-2"
                >
                    $DotsSixVertical
                  </v-icon>

                {{ item.descricao }}
              </span>

              <v-spacer />

              <v-btn icon x-small class="ml-2" @click="adicionarItem(item)">
                <v-icon color="#4075FF" size="15">$CaretRight</v-icon>
              </v-btn>
            </li>
          </ul>

          <div class="pa-2" v-if="ITENS_NAO_SELECIONADOS.length <= 0">
            <p>Nenhuma coluna encontrada.</p>
          </div>
        </div>
      </div>

      <div class="w-60-porcento pl-1">
        <div class="border-gray-400 w-100-porcento px-4 py-2 header-list">Campos selecionados para ordenação</div>
        <div class="border-gray-400 h-300px overflow-y-auto" @dragover="dragoverBloco">
          <ul class="list-style-type-none ml-n6 ">
            <li
              v-for="(item, key) in itens_selecionados"
              :key="key"
              class="d-flex align-center h-30px bg-white pa-5 cursor-grab"
              :class="{
                'item-sendo-arrastado': item_sendo_arrastado && item_sendo_arrastado.campo === item.campo
              }"
              :draggable="true"
              @dragstart="() => item_sendo_arrastado = item"
              @dragover="() => dragover(item)"
              @dragend="() => item_sendo_arrastado = null"
            >
              <span style="color: #0f172a" class="font-13 text-gray-1100 d-flex align-center">
                <v-icon
                  color="#0f172a"
                  size="22"
                  class="drag-icon mr-2"
                >
                  $DotsSixVertical
                </v-icon>

                {{ item.descricao }}
              </span>

              <v-spacer />

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-small
                    outlined
                    rounded
                    color="#757575"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span class="font-11">
                    Classificar
                    <template v-if="item.numerico"> do {{ item.ordem === 'DECRESCENTE' ? 'Maior pro Menor' : 'Menor pro Maior' }}</template>
                    <template v-else>de {{ item.ordem === 'DECRESCENTE' ? 'Z a A' : 'A a Z' }}</template>
                    </span>
                  </v-chip>
                </template>

                <v-list dense>
                  <v-list-item
                    v-for="(ordem, key) in ['CRESCENTE', 'DECRESCENTE']"
                    :key="key"
                    @click="item.ordem = ordem"
                  >
                    <v-list-item-title class="cursor-pointer font-weight-regular">
                      Classificar
                      <template v-if="item.numerico"> do {{ ordem === 'DECRESCENTE' ? 'Maior pro Menor' : 'Menor pro Maior' }}</template>
                      <template v-else>de {{ ordem === 'DECRESCENTE' ? 'Z a A' : 'A a Z' }}</template>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn color="#4075FF" icon x-small class="ml-2" @click="removerItem(item)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </li>
          </ul>

          <div class="pa-2" v-if="itens_selecionados.length <= 0">
            <p>Nenhuma coluna ordenada.</p>
          </div>
        </div>
      </div>
    </div>

    <v-divider class="my-5" />

    <div class="d-flex justify-space-between">
      <span class="footer-text">
          {{ itens_selecionados.length }} de {{ ITENS_NAO_SELECIONADOS.length }} colunas ordenadas
        </span>

      <v-btn
        color="#2563FF"
        dark
        depressed
        rounded
        class="save-btn"
        @click="salvarOrdenacao"
      >
        Salvar
      </v-btn>
    </div>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import { computed, onMounted, ref, watch } from "vue";
import { logout } from "@/helpers";
import api from "@/api/api";

const props = defineProps({
  id_unico_preferencia: String,
  itens: Array,
  abrir_dialog_ordenacao_count: Number,
});

const emit = defineEmits(['update:ordenacao', 'campos:ordenacao']);

const dialog_ativo = ref(false);
watch(() => props.abrir_dialog_ordenacao_count, () => dialog_ativo.value = true);

const item_sendo_arrastado = ref(null);
const itens_selecionados = ref([]);

const ITENS_NAO_SELECIONADOS = computed(() => {
  return props.itens.filter(item => !itens_selecionados.value.some(cab => cab.campo === item.campo));
});

function dragover(item) {
  if (item_sendo_arrastado.value.campo === item.campo) return;

  const index_of = itens_selecionados.value.indexOf(item);
  itens_selecionados.value = itens_selecionados.value.filter(item => item.campo !== item_sendo_arrastado.value.campo);
  itens_selecionados.value.splice(index_of, 0, item_sendo_arrastado.value);
}

function itemEstaSelecionado(item) {
  return itens_selecionados.value.find(cab => cab.campo === item.campo);
}

function dragoverBloco() {
  if (itemEstaSelecionado(item_sendo_arrastado.value)) return;

  adicionarItem(item_sendo_arrastado.value)
}

function adicionarItem(item) {
  if (!item.ordem) {
    item.ordem = 'CRESCENTE';
  }

  itens_selecionados.value.push(item);
}

function removerItem(item) {
  if (!itemEstaSelecionado(item)) return;
  itens_selecionados.value = itens_selecionados.value.filter(cab => cab.campo !== item.campo);
}

onMounted(buscarOrdenacao);

function buscarOrdenacao() {
  api.get(`preferencias/usuarios/${localStorage.id}/tabelas/${props.id_unico_preferencia}`)
  .then(resposta => {
    if (!resposta.data.preferencia) {
      return;
    }

    const preferencias = JSON.parse(resposta.data.preferencia.preferencias);

    itens_selecionados.value =
      preferencias.filter(pref => props.itens.findIndex(item => item.campo == pref.campo) != -1).map(pref => {
      const item = props.itens.find(item => item.campo === pref.campo);
      item.ordem = pref.ordem;
      return item;
    });

    emitirEventoOrdenacao();
  })
  .catch(logout)
}

function salvarOrdenacao() {
  const campos = itens_selecionados.value.map(item => ({
    campo: item.campo,
    ordem: item.ordem || 'CRESCENTE',
    inverter_ordenacao: item.inverter_ordenacao || false,
  }));

  api.post(`preferencias/usuarios/${localStorage.id}/tabelas/${props.id_unico_preferencia}`, campos)
  .then(() => {
    dialog_ativo.value = false;
    emit('update:ordenacao', itens_selecionados.value.map(item => ({...item})));
    emitirEventoOrdenacao();
  })
  .catch(logout)
}

function emitirEventoOrdenacao() {
  if (!itens_selecionados.value.length) {
    return;
  }

  emit('campos:ordenacao', itens_selecionados.value.map(item => ({...item})));
}
</script>

<style scoped>
.item-sendo-arrastado {
  border: 0.11rem dashed #4075FF;
}

.header-list {
  background-color: #F9FAFB;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
}

.save-btn {
  min-width: 96px;
  height: 34px !important;
  border-radius: 8px !important;
  letter-spacing: 0;
  font-weight: 500;
}

.drag-icon {
  color: #94a3b8;
  cursor: grab;
  flex-shrink: 0;
}

.footer-text {
  font-size: 13px;
  color: #64748b;
}
</style>
